import { getBooleanQueryParam } from "utils";

export default function isPrebidDebugEnabled() {
  return getBooleanQueryParam("pbjs_debug");
}
